import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { ContentSlider } from '@/components/molecules/ContentSlider/ContentSlider'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { SectionProps } from './types'

// Desktop spaces

export function HappyClientsSection({ heading, body, testimonials }: SectionProps) {
  return (
    <div className="desktop:bg-clients desktop:bg-no-repeat desktop:bg-top-15" id={kebabCase(heading)}>
      <section className="py-24 tablet:py-64 max-w-screen-desktop mx-auto px-24 laptop:px-90 tablet:text-center">
        <h2 className="text-headingM-mobile text-text-dark-900 font-poppins font-bold mb-24 netbook:text-headingM max-w-4xl mx-auto">
          {heading}
        </h2>
        <div className="text-bodyM netbook:text-bodyL text-text-dark-900 mb-40 max-w-44 mx-auto netbook:mb-80">
          {typeof body === 'string' ? body : <RichTextField data={body} />}
        </div>
        <ContentSlider content={testimonials} />
      </section>
    </div>
  )
}
